import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import iconMastercard from './icon-mc.svg';
import iconVisa from './icon-visa.svg';
import iconAmex from './icon-amex.svg';
import iconDiscover from './icon-discover.svg';
import iconSecure from './icon-secure.png';
import './CreditCardLogos.css';

const propTypes = {
  activeLink: PropTypes.string,
  className: PropTypes.string,
};

class CreditCardLogos extends PureComponent {
  render() {
    return (
      <Fragment>
        <div
          className={classnames(this.props.className, 'CreditCardLogos-logos')}
        >
          <img
            className="CreditCardLogos-logos-icon"
            src={iconVisa}
            alt="Visa logo"
          />
          <img
            className="CreditCardLogos-logos-icon"
            src={iconMastercard}
            alt="Mastercard logo"
          />
          <img
            className="CreditCardLogos-logos-icon"
            src={iconAmex}
            alt="Amex logo"
          />
          <img
            className="CreditCardLogos-logos-icon"
            src={iconDiscover}
            alt="Discover logo"
          />
          <img
            className="CreditCardLogos-logos-icon CreditCardLogos-logos-icon--secure"
            src={iconSecure}
            alt="Security logo"
          />
        </div>
        <div
          className={classnames(
            this.props.className,
            'CreditCardLogos-connection'
          )}
        >
          <span className="CreditCardLogos-connection-icon fas fa-lock" />
          <p className="CreditCardLogos-connection-text">
            All transactions are secure and encrypted.
          </p>
        </div>
      </Fragment>
    );
  }
}

CreditCardLogos.propTypes = propTypes;

export default CreditCardLogos;
